module.exports = __webpack_public_path__ + "img/jiaohuan.28d490f9.png";